/* eslint-disable max-len */
import React from 'react';
import {
    Box,
    Typography,
    Alert,
    TextField,
    FormControl,
    FormLabel,
} from '@mui/material';
import ActionButtonsFormularioAgricultura from 'components/forms/ActionButtonsFormularioAgricultura';
import { ContainerForm } from 'components/shared/container_form';
import InputComLabel from '../../../../../../components/shared/custom_input_label';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';

const Step7: React.FC = () => {
    const { formulario, setPartialForm } =
        useFormularioSecretariaMunicipalAgriculturaStore();

    // Ano de referência automático (ano atual)
    const anoAtual = new Date().getFullYear();

    // Definir ano de referência automaticamente
    React.useEffect(() => {
        if (!formulario?.ano_referencia || formulario.ano_referencia !== anoAtual) {
            setPartialForm('ano_referencia', anoAtual);
        }
    }, [anoAtual, formulario?.ano_referencia, setPartialForm]);

    // Texto explicativo da Lei nº 11.326/2006
    const textoLeiAgricultura = `Conforme a Lei nº 11.326/2006, é considerada agricultura familiar a prática de atividades no meio rural que atenda, simultaneamente, aos seguintes requisitos: o núcleo familiar não detenha, a qualquer título, área maior do que 4 módulos fiscais; a mão de obra seja predominantemente da própria família nas atividades econômicas do estabelecimento ou empreendimento; um percentual mínimo da renda familiar seja originado de atividades econômicas do estabelecimento ou empreendimento, na forma definida pelo Poder Executivo; e o estabelecimento ou empreendimento seja gerenciado pela família.`;

    // Validações
    const camposObrigatoriosPreenchidos =
        (formulario?.quantidade_familias_agricultura_familiar || 0) > 0 &&
        (formulario?.quantidade_familias_agricultura_familiar_beneficiadas_total || 0) > 0 &&
        (formulario?.quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas || 0) > 0;

    const podeAvancar = camposObrigatoriosPreenchidos;

    return (
        <>
            <ContainerForm title='Famílias Atendidas'>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} gap={4} display={'flex'} flexDirection={'column'}>

                    {/* Ano de Referência */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                            Ano de Referência do Questionário
                        </Typography>
                        <FormControl sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <FormLabel sx={{ color: '#333', fontWeight: 'bold' }}>
                                <span style={{ color: 'red', fontSize: '15px', marginRight: '4px' }}>*</span>
                                Ano de referência (preenchimento automático)
                            </FormLabel>
                            <TextField
                                variant='outlined'
                                type='number'
                                required
                                value={formulario?.ano_referencia?.toString() || anoAtual.toString()}
                                placeholder={anoAtual.toString()}
                                disabled
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f5f5f5',
                                        '& fieldset': {
                                            borderColor: '#e0e0e0',
                                        },
                                    },
                                }}
                            />
                        </FormControl>
                        <Typography variant="caption" sx={{ color: '#666', mt: 1, display: 'block' }}>
                            * Este campo é preenchido automaticamente e não pode ser editado
                        </Typography>
                    </Box>

                    {/* Primeira Pergunta - Quantas famílias existem */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                            1. Quantas famílias da agricultura familiar existem no município?
                        </Typography>

                        <Alert severity="info" sx={{ mb: 2 }}>
                            <Typography variant="body2">
                                <strong>Lei nº 11.326/2006:</strong><br />
                                {textoLeiAgricultura}
                            </Typography>
                        </Alert>

                        <InputComLabel
                            valor={formulario?.quantidade_familias_agricultura_familiar?.toString() || ''}
                            setValor={(valor) => setPartialForm('quantidade_familias_agricultura_familiar', Number(valor))}
                            labelTexto='Número de famílias da agricultura familiar'
                            placeholder='Digite o número de famílias'
                            type='number'
                            required
                        />
                    </Box>

                    {/* Segunda Pergunta - Quantas famílias foram beneficiadas */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                            2. Quantas famílias de agricultores familiares foram beneficiadas pela Secretaria/Órgão Municipal de Agricultura no último ano?
                        </Typography>

                        <Alert severity="info" sx={{ mb: 2 }}>
                            <Typography variant="body2">
                                <strong>Lei nº 11.326/2006:</strong><br />
                                {textoLeiAgricultura}
                            </Typography>
                        </Alert>

                        <InputComLabel
                            valor={formulario?.quantidade_familias_agricultura_familiar_beneficiadas_total?.toString() || ''}
                            setValor={(valor) => setPartialForm('quantidade_familias_agricultura_familiar_beneficiadas_total', Number(valor))}
                            labelTexto='Número de famílias beneficiadas'
                            placeholder='Digite o número de famílias beneficiadas'
                            type='number'
                            required
                        />

                        <Typography variant="caption" sx={{ color: '#666', mt: 1, display: 'block' }}>
                            * Se houver informações do ano anterior, elas serão exibidas automaticamente
                        </Typography>
                    </Box>

                    {/* Terceira Pergunta - Quantas são quilombolas */}
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                            3. Quantas são de comunidades quilombolas?
                        </Typography>

                        <InputComLabel
                            valor={formulario?.quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas?.toString() || ''}
                            setValor={(valor) => setPartialForm('quantidade_familiaa_agricultura_familiar_quilombolas_beneficiadas', Number(valor))}
                            labelTexto='Número de famílias quilombolas beneficiadas'
                            placeholder='Digite o número de famílias quilombolas'
                            type='number'
                            required
                        />
                    </Box>

                </Box>

                <ActionButtonsFormularioAgricultura disabled={!podeAvancar} />
            </ContainerForm>
        </>
    );
};

export default Step7; 